// extracted by css-extract-rspack-plugin
export default {"card":"D7Aud"};